import { OLC4O } from "../../data/OSSD/Grade12/OLC4O";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";

export default function OLC4OPage() {
    return (
        <div>
            <GradeCourseTemplate data={OLC4O} />
        </div>
    )
}